module.exports = __webpack_public_path__ + "img/hes-inf.ed26595f.jpg";